/* 

----- Client End Search ----- 
- Searches the DOM for a string.
*/


// Dependancey
// Case insensitive selector.
jQuery.expr[':'].icontains = function(a, i, m) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};

function initialise(context) {
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(2,"Client Search: Attempting to initalise", context);
    }

    let id = generateId();
    // Get submit button.
    let submitButton = (context.next().attr(expressSelectors()['client-search']['submit-button']) != undefined ? context.next() : "");    
    if (submitButton.length == 0 && AXISDebug.level() >= 2) {
        AXISDebug.output(2,"Client Search: Could not find submit button");
    }
    // Are we in a modal? 
    let modal = (context.parents(['data-modal']) != undefined ? true : false);
    let modalContainer = context.parents('[' + expressSelectors()['modals']['modal-context'] + ']');


    let content;
    if (modal) {
        // Get the modal context.
        content = modalContainer.find('[' + expressSelectors()['client-search']['content'] + ']')
    } else {
        content = $('[' + expressSelectors()['client-search']['content'] + ']');
    }

    // Assign id.
    context.attr('client-search', id);
    // Add Listeners.
    context.on('change', function() {
        // Grab context.
        let input = $(this);
        // Query.
        let query = input.val();
        // Do the search.
        let search = doSearch(query, modalContainer);
    });
    // If submit button defined.
    if (submitButton.length > 0) {
        submitButton.on('click', function() {
            let query = context.val();
            // Do the search.
            let search = doSearch(query, modalContainer);
        });
    }
}

function doSearch(query, modalContainer) {
    // Define matched results count.
    let matchedResults = 0;
    // Find the no results container.
    let noResultsContainer = modalContainer.find('[' + expressSelectors()['client-search']['no-results'] + ']');
    // Find results container.
    let resultsContainer = modalContainer.find('[' + expressSelectors()['client-search']['content'] + ']');
    // Only if you're a modal.
    // TODO: there should be a modals function to get the proceed context, this is a very manual process being carried out here..
    let proceedButton = modalContainer.find(expressSelectors()['modals']['proceed-button']);

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Branch Select Search looking for: " + query);
    }

    // Go through the list of branches and hide the ones that don't match the query.
    if (modalContainer) {
        // Get list of item to query.
        let list = modalContainer.find('[' + expressSelectors()['client-search']['item'] + ']');
        // Loop throug each item.
        list.each(function() {
            // Item context.
            let item = $(this);
            // Run test against query.
            if (item.is(':icontains(' + query + ')')) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Client Search: Match Found", item);
                }
                //Match found!
                item.parent('tr').css('display','table-row');
                //Increment the matched results.
                matchedResults++;
            } else {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Client Search: No Match Found for query " + query, item);
                }
                // Hide all items that dont match.
                item.parent('tr').css('display','none');
            }
        });

        if (!matchedResults) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Client Search: No results found attempting to show no results element");
            }
            noResultsContainer.addClass('active');

            resultsContainer.css('display', 'none');

            if (proceedButton) {
                proceedButton.css('display', 'none');
            }
        } else if (noResultsContainer.hasClass('active')) {
            noResultsContainer.removeClass('active');

            resultsContainer.css('display', 'block');

            if (proceedButton) {
                proceedButton.css('display', 'block');
            }
        }
    } else {
        console.warn("CLIENT SEARCH DOES NOT WORK OUTSIDE OF THE CONTEXT OF MODALS ATM")
    }
}





var clientSearch = $.animations = {
    initialise: (context) => {
        return initialise(context);
    }
}
  
export { clientSearch };